import React, { useMemo } from 'react';
import { useMessagerieNotification } from '@europrocurement/l2d-modules';
import { HeaderNotificationsContext } from '@europrocurement/flexy-components';

const L2DFNotificationsProvider: React.FunctionComponent<{ children: React.ReactNode }> =
    function ({ children }) {
        const { messageItems, notificationItems } = useMessagerieNotification();
        const value = useMemo(
            () => ({ itemsMessage: messageItems, itemsNotification: notificationItems }),
            [messageItems, notificationItems],
        );
        return (
            <HeaderNotificationsContext.Provider value={value}>
                {children}
            </HeaderNotificationsContext.Provider>
        );
    };

export default L2DFNotificationsProvider;
